import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import _isEmpty from "lodash/isEmpty";
import React from 'react';
import PropTypes from 'prop-types';
import { checkHistoryLog } from "../../services/api";
import { getResponse } from "../../utils/utils";
import { FAILURE, SUCCESS } from "./Status";
var DELAY = 500;
var HistoryProvider = /*#__PURE__*/function (_React$Component) {
  _inherits(HistoryProvider, _React$Component);
  var _super = _createSuper(HistoryProvider);
  function HistoryProvider() {
    var _this;
    _classCallCheck(this, HistoryProvider);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.delayId = 0;
    _this.allHistoryLogs = new Set();
    _this.historyLogs = new Map();
    _this.params = new Map();
    _this.queue = new Set();
    _this.handlers = new Set();
    _this.check = function (props, handler, flag) {
      // 设置了 path 属性才去验证权限，没设置权限将直接返回失败状态
      _this.queue.clear();
      if (!props.path) {
        handler(FAILURE);
      } else {
        var _props$path = props.path,
          path = _props$path === void 0 ? '' : _props$path;
        var queue = new Set();
        var isCheckThrough = false; // 找到对应的需要验证权限的对象

        if (path) {
          _this.allHistoryLogs.add(path);
          var key = path; // 获取对应待验证对象的权限状态

          var status = _this.historyLogs.get(key); // 验证成功后执行回调函数，结束验证

          if (status === SUCCESS) {
            var ctlType = _this.params.get(path);
            handler(status, ctlType);
            isCheckThrough = false;
          } else if (status === FAILURE) {
            isCheckThrough = true;
          } else if (status !== FAILURE) {
            // 没有被验证的放入队列中等待下次验证
            _this.queue.add(key);
            queue.add(key);
            isCheckThrough = true;
          } else {
            isCheckThrough = true;
          }
        }
        if (isCheckThrough) {
          // 再一次验证剩余的权限
          if (queue.size > 0 && !flag) {
            _this.handlers.add([props, handler]);
            _this.start();
          } else {
            // 鉴权失败后执行回调函数
            var _ctlType = _this.params.get(path) || undefined;
            handler(FAILURE, _ctlType);
            return true;
          }
        }
      }
    };
    return _this;
  }
  _createClass(HistoryProvider, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        historyLog: this
      };
    } // 定时器对象
  }, {
    key: "fetchHistory",
    /**
     * 请求接口验证权限集
     */
    value: function fetchHistory() {
      var _Array$from,
        _Array$from2,
        _this2 = this;
      var handlers = Array.from(this.handlers);
      var pageRoute = (_Array$from = Array.from(this.queue)) === null || _Array$from === void 0 ? void 0 : _Array$from[0];
      checkHistoryLog({
        pageRoute: (_Array$from2 = Array.from(this.queue)) === null || _Array$from2 === void 0 ? void 0 : _Array$from2[0]
      }).then(function (data) {
        if (!_isEmpty(getResponse(data))) {
          _this2.historyLogs.set(pageRoute, data.enabledFlag ? SUCCESS : FAILURE);
          _this2.params.set(pageRoute, {
            documentCode: data.documentCode,
            businessKey: data.businessKey
          }); // 处理权限

          handlers.forEach(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
              props = _ref2[0],
              handler = _ref2[1];
            return _this2.check(props, handler, true);
          });
        } else {
          _this2.historyLogs.set(pageRoute, FAILURE);
          _this2.params.set(pageRoute, {}); // 处理权限

          handlers.forEach(function (_ref3) {
            var _ref4 = _slicedToArray(_ref3, 2),
              props = _ref4[0],
              handler = _ref4[1];
            return _this2.check(props, handler, true);
          });
        }
      });
    }
    /**
     * 开始验证权限，处理延迟
     */
  }, {
    key: "start",
    value: function start() {
      var _this3 = this;
      if (this.delayId) {
        clearTimeout(this.delayId);
      }
      this.delayId = setTimeout(function () {
        _this3.fetchHistory();
        _this3.queue.clear();
        _this3.handlers.clear();
      }, DELAY);
    }
    /**
     * 处理权限
     * @param {object} props - 参数
     * @param {function} handler - 回调函数
     * @param {boolean} flag - 标记
     */
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
  return HistoryProvider;
}(React.Component);
HistoryProvider.childContextTypes = {
  historyLog: PropTypes.object
};
export { HistoryProvider as default };